import Modal from "components/common/controls/modal/Modal";
import RequestJsonViewer from "../HowItWorks/RequestJsonViewer";
import Button from "components/common/controls/Button";

interface Props {
  onClose: () => void;
  json: object;
}

export default function RequestJsonViewerPopup(props: Props) {
  const { onClose, json } = props;
  return (
    <Modal
      title="Request JSON"
      visible={true}
      onClose={onClose}
      minWidth="471px"
      maxWidth="600px"
      height="680"
      displayDefaultActions={false}
    >
      <RequestJsonViewer json={json} maxHeightClass="max-h-120"/>
      <div className="mt-6 float-right">
        <Button text="Close" onClick={onClose} />
      </div>
    </Modal>
  );
}
